import type { ReactNode } from 'react';
import { Sparkline } from '../charts/Sparkline';

interface Props {
  label: string;
  value: ReactNode;
  unit?: string;
  delta?: { value: number; text: string; period: string } | null;
  trend?: number[];
  trendColor?: string;
  hint?: string;
  accent?: string;
}

/** Stat tile: label · value · optional signed delta (icon + status colour) · optional sparkline. */
export function StatTile({ label, value, unit, delta, trend, trendColor = 'var(--accent)', hint, accent }: Props) {
  const up = delta && delta.value > 0;
  const down = delta && delta.value < 0;
  return (
    <div className="stat-tile panel" title={hint}>
      <div className="stat-label">
        {accent && <i className="stat-dot" style={{ background: accent }} aria-hidden />}
        {label}
      </div>
      <div className="stat-value">
        {value}
        {unit && <span className="stat-unit">{unit}</span>}
      </div>
      {delta && (
        <div className={`stat-delta ${up ? 'good' : down ? 'bad' : ''}`}>
          <span aria-hidden>{up ? '▲' : down ? '▼' : '■'}</span> {delta.text} <span className="muted">{delta.period}</span>
        </div>
      )}
      {trend && trend.length > 1 && <Sparkline values={trend} color={trendColor} label={`${label} trend`} />}
    </div>
  );
}
